

export enum AuthType {
  VERIFICATION_CODE = 1,
  PASSWORD = 2
}

